import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import Octicon from "react-octicon";

// Custom Dropdown Component
export default function CustomDropdown({ items, alignLeft, buttonText = <Octicon name="gear" /> }) {
  const [isOpen, setIsOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, right: 0 });
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isOpen]);

  const handleButtonClick = () => {
    if (!isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const pixelsFromRight = window.innerWidth - rect.right;
      const pixelsFromLeft = rect.left + window.scrollX;
      setMenuPosition({
        top: rect.bottom + window.scrollY,
        ...(alignLeft ? { left: pixelsFromLeft } : { right: pixelsFromRight }),
      });
    }
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item) => {
    if (item.onClick) {
      item.onClick();
    }
    setIsOpen(false);
  };

  const menuPositionPixels = Object.entries(menuPosition).reduce((acc, [key, value]) => {
    acc[key] = `${value}px`;
    return acc;
  }, {});

  const menuStyles = {
    ...menuPositionPixels,
    position: "absolute",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "4px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    minWidth: "160px",
    zIndex: 10000,
    padding: "4px 0",
  };

  const itemStyles = {
    padding: "8px 16px",
    cursor: "pointer",
    borderBottom: "1px solid #f0f0f0",
    fontSize: "14px",
  };

  const dividerStyles = {
    height: "1px",
    backgroundColor: "#e0e0e0",
    margin: "4px 0",
  };

  const buttonStyles = {
    padding: "6px 12px",
    backgroundColor: "transparent",
    color: "black",
    border: "1px solid black",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
  };

  return (
    <>
      <button ref={buttonRef} onClick={handleButtonClick} style={buttonStyles}>
        {buttonText} ▼
      </button>
      {isOpen &&
        createPortal(
          <div ref={menuRef} style={menuStyles}>
            {items.map((item, index) => {
              // Check if it's a divider (empty object)
              if (!item.name) {
                return <div key={index} style={dividerStyles} />;
              }
              return (
                <div
                  key={index}
                  style={itemStyles}
                  onClick={() => handleItemClick(item)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  {item.name}
                </div>
              );
            })}
          </div>,
          document.body
        )}
    </>
  );
}
